import { Stack, Text } from '@mantine/core';

import { ChapterValidationAction } from '@/module/Author/Chapter/Validation/ChapterValidationAction';
import { ChapterValidationHistory } from '@/module/Author/Chapter/Validation/ChapterValidationHistory';
import { ChapterDeleteButton } from '@/module/Author/Chapter/components/ChapterDeleteButton';
import { PublicationContent } from '@/module/Author/Publication/components/PublicationContent';

import { Content, EditButtonLink } from '@/core/components';

import { AuthorList, BdiList, PublicationPages, PublisherLink } from '@feature/utils';

import { ViewCitationsButton } from '../Citation/components/ViewCitationsButton';
import { Chapter } from './model/ChapterTypes';

interface ChapterViewProps {
  chapter: Chapter;
}

export function ChapterView({ chapter }: ChapterViewProps) {
  const { authors, noOfPages, publisher, startPage, endPage, bookName, bookSeries, publisherType, bdis } = chapter;

  return (
    <Stack>
      <PublicationContent
        publication={chapter}
        authorsNo={authors.length}
        actions={
          <>
            <EditButtonLink
              size="xs"
              miw="100px"
            />
            <ChapterDeleteButton chapterId={chapter.id} />
          </>
        }
      />
      <ViewCitationsButton
        entityId={chapter.id}
        entityType="CHAPTER"
      />
      <Content type="full">
        <Stack gap="xs">
          {publisher && (
            <PublisherLink
              publisherId={publisher.id}
              title={publisher.title}
            />
          )}
          {publisherType && <Text>Tip editura: {publisherType.name}</Text>}
          <PublicationPages
            noOfPages={noOfPages ?? 0}
            endPage={endPage ?? 0}
            startPage={startPage ?? 0}
          />
          {bookName && <Text>{bookName}</Text>}
          {bookSeries && <Text>{bookSeries}</Text>}
          <BdiList bdis={bdis} />
        </Stack>
      </Content>
      <Content type="full">
        <AuthorList authors={authors} />
      </Content>
      <ChapterValidationAction chapterId={chapter.id} />
      <ChapterValidationHistory chapterId={chapter.id} />
    </Stack>
  );
}
